import { Provider } from 'react-redux';
import { store } from '../../lib/store';
import { FeedbackModal } from './index';
import type { FeedbackModalProps } from './types';

/**
 * Wrapper component that provides Redux context for FeedbackModal
 * This is needed when FeedbackModal is rendered in portals (like SweetAlert2)
 * that might not preserve the React context
 */
export function FeedbackModalWrapper(props: FeedbackModalProps) {
  return (
    <Provider store={store}>
      <FeedbackModal {...props} />
    </Provider>
  );
}
